import {
  MessageResponseDto,
  GetPaymentDto,
  PaymentControllerGet200Response,
  PaymentApiFp,
  DeletePaymentDto,
  CreatePaymentBaseDto,
  EditPaymentBaseDto,
  CreatePaymentBulkBaseDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponsePaymentModel = PaymentControllerGet200Response;
export type GetPaymentModel = GetPaymentDto;
export type MutateResponsePaymentModel = MessageResponseDto;
export type CreatePaymentModel = CreatePaymentBaseDto;
export type CreateBulkPaymentModel = CreatePaymentBulkBaseDto;
export type UpdatePaymentModel = EditPaymentBaseDto;
export type DeletePaymentModel = DeletePaymentDto;

export interface CreatePaymentModelExtension {
  payment: CreatePaymentModel;
  file: File;
}
export interface UpdatePaymentModelExtension {
  payment: UpdatePaymentModel;
  file: File;
}
export interface CreateBulkPaymentModelExtension {
  payment: CreateBulkPaymentModel;
  file: File;
}

export const apiPaymentFp = PaymentApiFp(apiConfig);
export const getPaymentController = apiPaymentFp.paymentControllerGet;
export const createPaymentController = apiPaymentFp.paymentControllerCreate;
export const createBulkPaymentController = apiPaymentFp.paymentControllerPayBulk;
export const updatePaymentController = apiPaymentFp.paymentControllerEdit;
export const deletePaymentController = apiPaymentFp.paymentControllerDelete;

export const QueryKeyPayment = QueryKey.Payment;
